// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gray{color:#292727}.product{padding:0.5rem}.product .premium{color:#dabc64;font-size:1rem;margin-bottom:1rem}.product .star{padding-right:0.5rem;color:#dabc64}.product .purchased{color:#292727;font-size:1rem;text-align:center}.product button.pill{font-size:1rem}.product .tooltip-wrapper{padding-left:0.5rem}.product .tooltip-wrapper .tooltip-contents{width:15rem;max-width:100vw;left:1.6rem}\n", ""]);
// Exports
module.exports = exports;
